var map = {
	"./Amber/Defense potion.json": 6146,
	"./Amber/Equilibrium potion.json": 74945,
	"./Amber/Power potion.json": 31908,
	"./Amber/Shock potion.json": 58890,
	"./Amber/Stone potion.json": 54303,
	"./Beryl/Fission potion.json": 40768,
	"./Beryl/Moss potion.json": 70985,
	"./Beryl/Overgrowth potion.json": 57747,
	"./Beryl/Photosynthesis potion.json": 62806,
	"./Beryl/Quaking potion.json": 62896,
	"./Beryl/Tangle potion.json": 49563,
	"./Common/Attack potion.json": 9243,
	"./Common/Block potion.json": 2100,
	"./Common/Channeling potion.json": 57214,
	"./Common/Chaos potion.json": 52541,
	"./Common/Cheese potion.json": 41980,
	"./Common/Cleansing potion.json": 44811,
	"./Common/Cloudy potion.json": 17815,
	"./Common/Corruption potion.json": 11408,
	"./Common/Creative potion.json": 42875,
	"./Common/Curing potion.json": 18266,
	"./Common/Duplication potion.json": 58607,
	"./Common/Echo potion.json": 97714,
	"./Common/Entropy potion.json": 57721,
	"./Common/Experience potion.json": 6830,
	"./Common/Explosive potion.json": 36497,
	"./Common/Fairy in a bottle.json": 57283,
	"./Common/Flash potion.json": 47529,
	"./Common/Gold potion.json": 45187,
	"./Common/Health potion.json": 14779,
	"./Common/Instinct potion.json": 52137,
	"./Common/Mana potion.json": 35068,
	"./Common/Mirage potion.json": 28656,
	"./Common/Nectar.json": 2368,
	"./Common/Phantom potion.json": 1249,
	"./Common/Repeat potion.json": 47727,
	"./Common/Resonance potion.json": 26276,
	"./Common/Serenity potion.json": 31904,
	"./Common/Shieldbreaker potion.json": 42237,
	"./Common/Shop in a bottle.json": 10516,
	"./Common/Smoke bomb.json": 59715,
	"./Common/Special potion.json": 5829,
	"./Common/Sticky potion.json": 10699,
	"./Common/Swift potion.json": 95075,
	"./Common/Tamer's potion.json": 41003,
	"./Common/Timewarp potion.json": 65861,
	"./Common/Trickster potion.json": 48281,
	"./Common/Void potion.json": 39043,
	"./Extra/Cute drawing.json": 44683,
	"./Extra/Dragon's tears.json": 50812,
	"./Pearl/Chill potion.json": 53755,
	"./Pearl/Milk potion.json": 45935,
	"./Pearl/Refreshing potion.json": 45635,
	"./Pearl/Slime potion.json": 79068,
	"./Pearl/Thorns potion.json": 6260,
	"./Ruby/Domination potion.json": 82416,
	"./Ruby/Fear potion.json": 57916,
	"./Ruby/Pheromone potion.json": 37650,
	"./Ruby/Tension potion.json": 97634,
	"./Ruby/Virility potion.json": 57059,
	"./Shared/Rage potion.json": 29316,
	"./Spinelle/Acrobatics potion.json": 29965,
	"./Spinelle/Flip potion.json": 73295,
	"./Spinelle/Intensity potion.json": 56454,
	"./Spinelle/Momentum potion.json": 29144,
	"./Spinelle/Zen potion.json": 11641,
	"./Unused/Amnesia potion.json": 79514,
	"./Unused/Armored scarab.json": 49696,
	"./Unused/Cold incense.json": 43123,
	"./Unused/Crystalline potion.json": 35633,
	"./Unused/Demonic potion.json": 70572,
	"./Unused/Earthbound potion.json": 57718,
	"./Unused/Growth fruit.json": 27201,
	"./Unused/Holy water.json": 92111,
	"./Unused/Hot incense.json": 15836,
	"./Unused/Insight potion.json": 92174,
	"./Unused/Medicinal herb.json": 55850,
	"./Unused/Poison potion.json": 93390,
	"./Unused/Radiance potion.json": 22549,
	"./Unused/Ruby potion.json": 20169,
	"./Unused/Spike potion.json": 29186,
	"./Unused/Spiritual potion.json": 81908,
	"./Unused/Strange potion.json": 59493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51783;